import { render, staticRenderFns } from "./OMAccordion.vue?vue&type=template&id=444c2c5f&scoped=true"
import script from "./OMAccordion.vue?vue&type=script&lang=js"
export * from "./OMAccordion.vue?vue&type=script&lang=js"
import style0 from "./OMAccordion.vue?vue&type=style&index=0&id=444c2c5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../omniscient/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444c2c5f",
  null
  
)

export default component.exports